import React from 'react';
import cx from 'classnames';

const stripAtSign = str => str.replace('@', '');

class MultiDomainEmailInput extends React.Component {
  constructor() {
    super(...arguments);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.handleDomainChange = this.handleDomainChange.bind(this);
  }

  handleUserChange(e) {
    const user = stripAtSign(e.target.value);
    const domain = this.props.email.split('@')[1] || this.props.domains[0];
    this.props.onEmailChange(`${user}@${domain}`);
  }

  handleDomainChange(e) {
    const user = this.props.email.split('@')[0];
    const domain = e.target.value;
    this.props.onEmailChange(`${user}@${domain}`);
  }

  render() {
    const domains = this.props.domains;
    const segments = this.props.email.split('@');
    const user = segments[0];
    const domain = segments[1] || domains[0];

    return (
      <div className="EmailInput">
        <div className="EmailInput__User">
          <input
            className={cx({
              EmailInput__Input: true,
              'EmailInput__Input--invalid': this.props.invalid,
            })}
            value={user}
            onChange={this.handleUserChange}
          />
        </div>
        <span className="EmailInput__AtSign">@</span>
        <div>
          <select
            className="EmailInput__Input"
            value={domain}
            onChange={this.handleDomainChange}
          >
            {domains.map(d => (
              <option key={d} value={d}>
                {d}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

export default MultiDomainEmailInput;
